/*
  Prev/next navigation for the PDP desktop media gallery (thumbnails layout),
  plus keeping the active thumbnail fully visible in both desktop and mobile
  thumbnail tracks.
*/
(function () {
  var NAV_BUTTON_SELECTOR = '[data-custom-pdp-media-nav]';
  var THUMB_SELECTOR = '[data-product-thumbnail]';
  var DESKTOP_GALLERY_SELECTOR = '.product__media-container.above-mobile';
  var VIEWPORT_SELECTOR = '[data-scroll-container-viewport]';
  var SCROLL_EDGE_BUFFER = 3;

  function getActiveIndex(thumbs, gallery) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('active')) return i;
    }

    var visibleItem = gallery.querySelector('.product__media-item:not(.hidden)');
    if (visibleItem) {
      for (var j = 0; j < thumbs.length; j++) {
        if (thumbs[j].getAttribute('data-thumbnail-id') === visibleItem.getAttribute('data-media-item-id')) {
          return j;
        }
      }
    }

    return 0;
  }

  function scrollThumbFullyIntoView(thumb) {
    if (!thumb) return;

    var item = thumb.closest('.product-thumbnails__item') || thumb;
    var viewport = thumb.closest(VIEWPORT_SELECTOR);
    if (!viewport || !item) return;

    var thumbsRoot = thumb.closest('.product-thumbnails');
    var isVertical = thumbsRoot && thumbsRoot.getAttribute('data-axis') === 'vertical';
    var itemRect = item.getBoundingClientRect();
    var viewportRect = viewport.getBoundingClientRect();

    if (isVertical) {
      var nextScrollTop = viewport.scrollTop;

      if (itemRect.top < viewportRect.top + SCROLL_EDGE_BUFFER) {
        nextScrollTop -= viewportRect.top + SCROLL_EDGE_BUFFER - itemRect.top;
      } else if (itemRect.bottom > viewportRect.bottom - SCROLL_EDGE_BUFFER) {
        nextScrollTop += itemRect.bottom - (viewportRect.bottom - SCROLL_EDGE_BUFFER);
      } else {
        return;
      }

      viewport.scrollTo({
        top: Math.max(0, nextScrollTop),
        behavior: 'smooth',
      });
      return;
    }

    var nextScrollLeft = viewport.scrollLeft;

    if (itemRect.left < viewportRect.left + SCROLL_EDGE_BUFFER) {
      nextScrollLeft -= viewportRect.left + SCROLL_EDGE_BUFFER - itemRect.left;
    } else if (itemRect.right > viewportRect.right - SCROLL_EDGE_BUFFER) {
      nextScrollLeft += itemRect.right - (viewportRect.right - SCROLL_EDGE_BUFFER);
    } else {
      return;
    }

    // Prefer max scroll for the last item so end padding / border stay visible
    var maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    nextScrollLeft = Math.min(Math.max(0, nextScrollLeft), maxScrollLeft);

    viewport.scrollTo({
      left: nextScrollLeft,
      behavior: 'smooth',
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(NAV_BUTTON_SELECTOR);
    if (!button) return;

    var gallery = button.closest(DESKTOP_GALLERY_SELECTOR);
    if (!gallery) return;

    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll(THUMB_SELECTOR));
    if (thumbs.length < 2) return;

    var direction = button.getAttribute('data-custom-pdp-media-nav') === 'next' ? 1 : -1;
    var targetIndex = (getActiveIndex(thumbs, gallery) + direction + thumbs.length) % thumbs.length;
    var targetThumb = thumbs[targetIndex];

    targetThumb.click();
    requestAnimationFrame(function () {
      scrollThumbFullyIntoView(targetThumb);
    });
  });

  // Keep active thumb in view on mobile swipe / any active-state change
  var observedThumbs = new WeakSet();
  var thumbObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var thumb = mutation.target;
      if (!(thumb instanceof Element)) return;
      if (!thumb.matches(THUMB_SELECTOR)) return;
      if (!thumb.classList.contains('active')) return;
      scrollThumbFullyIntoView(thumb);
    });
  });

  function observeThumbs(root) {
    var scope = root || document;
    scope.querySelectorAll(THUMB_SELECTOR).forEach(function (thumb) {
      if (observedThumbs.has(thumb)) return;
      observedThumbs.add(thumb);
      thumbObserver.observe(thumb, { attributes: true, attributeFilter: ['class'] });
    });
  }

  observeThumbs(document);

  var productRoot = document.querySelector('[data-section-type="product"]');
  if (productRoot) {
    new MutationObserver(function () {
      observeThumbs(productRoot);
    }).observe(productRoot, { childList: true, subtree: true });
  }
})();
